module.exports = __webpack_public_path__ + "static/fonts/glyphicons-halflings-regular.fa27723.woff";


//////////////////
// WEBPACK FOOTER
// ./src/views/affiliatecard/font/glyphicons-halflings-regular.woff
// module id = AZ1k
// module chunks = 0